export default __webpack_public_path__ + "static/media/Blue Jackets.e6530fa6.png";